export const isSearchPage = document.querySelector( 'body' ).classList.contains( 'search' );
export const isArchivePage = document.querySelector( 'body' ).classList.contains( 'archive' );
export const maybePreventDefault = ( event ) => ! isModifierEvent( event ) && event.preventDefault();
export const encodePostTitle = ( title ) => encodeURIComponent( title );
export const decodePostTitle = ( title ) => decodeURIComponent( title );

export const getFacets = () => document.querySelector( '.algolia__block' )?.dataset?.facets;

export const filterTitle = ( post_type_label ) => {
	const label = post_type_label.toLowerCase();
	switch ( label ) {
		case 'mec-events':
			return 'Event';
		case 'page':
			return 'Page';
		case 'post':
			return 'Post';
		case 'product':
			return 'Product';
		case 'document':
			return 'Document';
		default:
			return '';
	}
};

// allow default browser behavior on certain key press
export const isModifierEvent = ( event ) => {
	const isMiddleClick = event.button === 1;

	return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
};

export const searchPanelOpen = document.querySelector( '.masthead' ).classList.contains( 'masthead--mode-search' );

export const debounce = ( func, timeout = 300 ) => {
	let timer;
	return ( ...args ) => {
		clearTimeout( timer );
		timer = setTimeout( () => func.apply( this, args ), timeout );
	};
};

export const getDelegateTarget = ( event, selector, root = document.documentElement ) => {
	let node = event.target;

	while ( node && node !== root ) {
		if ( node.matches( selector ) ) {
			return node;
		}
		node = node.parentNode;
	}
	return null;
};

export const parseTemplate = ( id, attributes ) => {
	const template = document.getElementById( `algolia-template--${ id }` );
	if ( ! template ) {
		console.log( `missing template ${ id }` );
		return;
	}
	return template.innerHTML.replace( /%(\w*)%/g, function ( m, key ) {
		return attributes.hasOwnProperty( key ) ? attributes[ key ] : '';
	} );
};

export const escapeHtml = ( html ) => {
	var text = document.createTextNode( html );
	var template = document.createElement( 'template' );
	template.appendChild( text );
	return template.innerHTML;
};

export const handleKeypress = ( event, container, cssClasses, refine ) => {
	// container?.offsetParent ensures that the current search ui is visible and doesn't hijack things like tab or enter
	if ( ! container?.offsetParent ) {
		return;
	}

	const key = event.keyCode;
	const { activeElement } = document;
	const shadow = container.querySelector( `.${ cssClasses.shadow }` );
	const input = container.querySelector( `.${ cssClasses.main }` );
	const list = container.querySelector( `.${ cssClasses.list }` );
	const hits = [ ...container.querySelectorAll( `.${ cssClasses.item }` ) ];

	if ( ! hits.length ) {
		return;
	}

	const nextIndex = parseInt( activeElement.dataset?.index, 10 ) + 1;
	const previousIndex = parseInt( activeElement.dataset?.index, 10 ) - 1;
	const inputHasFocus = activeElement.classList.contains( cssClasses.main );
	const hitHasFocus = activeElement.classList.contains( cssClasses.link );
	const first = list.querySelector( `[data-index="0"]` );
	const nextHit = list.querySelector( `[data-index="${ nextIndex }"]` );
	const previousHit = list.querySelector( `[data-index="${ previousIndex }"]` );

	const focusHit = ( hit ) => {
		const input = container.querySelector( `.${ cssClasses.main }` );
		const {
			dataset: { title },
			href,
		} = hit;
		hit.focus();

		if ( hitHasFocus ) {
			input.dataset.href = first.href;
		}
		shadow.innerHTML = decodePostTitle( title );
	};

	event.preventDefault();

	if ( key == 13 || key == 'Enter' ) {
		if ( input.dataset.href ) {
			window.location = input.dataset.href;
		} else {
			window.location = `${ window.location.origin }/site-search/?query=${ input.value }`;
		}

		return;
	}
	// event.stopImmediatePropagation();

	// tab press
	if ( key == 9 ) {
		nextHit ? focusHit( nextHit ) : first.focus();
		return;
	}

	if ( key == 40 || key == 38 ) {
		const input = container.querySelector( `.${ cssClasses.main }` );

		if ( ! ( hitHasFocus || inputHasFocus ) ) {
			return;
		}

		// down
		if ( key == 40 ) {
			if ( inputHasFocus ) {
				focusHit( first );
				return;
			}

			nextHit ? focusHit( nextHit ) : input.focus();
			return;
		}

		// up
		if ( key == 38 ) {
			if ( inputHasFocus ) {
				return;
			}

			previousHit ? focusHit( previousHit ) : input.focus();
		}
	}

	// if (key == 39) {
	// 	const nextChar = shadow.value[input.value.length];
	// 	console.log(nextChar);
	// }
};

export function executeFunctionByName( functionName, context /*, args */ ) {
	var args = Array.prototype.slice.call( arguments, 2 );
	var namespaces = functionName.split( '.' );
	var func = namespaces.pop();
	for ( var i = 0; i < namespaces.length; i++ ) {
		context = context[ namespaces[ i ] ];
	}
	return context[ func ].apply( context, args );
}

export const parseAttributes = ( dataset ) =>
	Object.keys( dataset ).reduce(
		( acc, key ) => ( {
			...acc,
			[ key ]: dataset[ key ],
		} ),
		{}
	);

export const transformOrigin = ( url ) => {
	if ( ! url ) {
		return;
	}

	const temp = new URL( url );
	return url;
	return url.replace( temp.origin, window.location.origin );
};
